import React from 'react';
import Button from 'material-ui/Button';
import Link from 'atoms/Link';

export default props => (
  <Button {...props} component={Link} />
);



// WEBPACK FOOTER //
// ./src/atoms/Link/LinkButton/index.js